import { EnumDescriptions } from '@/app/shared/utils';
import { i18n } from '@/plugins';

export enum PolicyStatus {
  Active = 1,
  Canceled = 2,
  Suspended = 3,
  Reactivated = 4,
}
EnumDescriptions.setDescriptions(PolicyStatus, [
  i18n.t('enums.active'),
  i18n.t('enums.canceled'),
  i18n.t('enums.suspended'),
  i18n.t('enums.reactivated'),
]);
